import React from 'react';

const SvgCg = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="CG_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="CG_svg__b" fill="#fff">
        <use xlinkHref="#CG_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#CG_svg__a" />
      <path
        fill="#F33630"
        mask="url(#CG_svg__b)"
        d="M6.667 18.667L26.667 0H28v20H6.667z"
      />
      <path
        fill="#009643"
        mask="url(#CG_svg__b)"
        transform="rotate(180 10.667 10)"
        d="M0 18.667L20 0h1.333v20H0z"
      />
      <path
        fill="#FCDF4A"
        mask="url(#CG_svg__b)"
        transform="rotate(134 14.412 9.533)"
        d="M-4.92 6.2h38.666v6.666H-4.921z"
      />
    </g>
  </svg>
);

export default SvgCg;
